import React, { useCallback, useEffect, useRef, useState } from 'react';

export const useInlineRename = (value: string, onCommit: (newName: string) => void) => {
    const [isEditing, setIsEditing] = useState(false);
    const [draft, setDraft] = useState(value);
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (isEditing) {
            inputRef.current?.focus();
            inputRef.current?.select();
        }
    }, [isEditing]);

    const startEditing = useCallback(() => {
        setDraft(value);
        setIsEditing(true);
    }, [value]);

    const commit = useCallback(() => {
        setIsEditing(false);
        const trimmed = draft.trim();
        if (trimmed && trimmed !== value) onCommit(trimmed);
    }, [draft, value, onCommit]);

    const cancel = useCallback(() => {
        setDraft(value);
        setIsEditing(false);
    }, [value]);

    const handleKeyDown = useCallback(
        (e: React.KeyboardEvent<HTMLInputElement>) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                commit();
            } else if (e.key === 'Escape') {
                e.preventDefault();
                cancel();
            }
        },
        [commit, cancel]
    );

    return { isEditing, draft, setDraft, inputRef, startEditing, commit, handleKeyDown };
};
